var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 37,
    stroke: "#6B35B5",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8079 46.1573C38.4364 46.5289 37.9973 46.7147 37.4906 46.7147C36.9839 46.7147 36.5448 46.5289 36.1733 46.1573C35.8017 45.7858 35.6159 45.3467 35.6159 44.84L35.1599 22.3947C35.1599 21.7191 35.3795 21.1618 35.8186 20.7227C36.2915 20.2498 36.8488 20.0133 37.4906 20.0133C38.1324 20.0133 38.6728 20.2498 39.1119 20.7227C39.5848 21.1618 39.8213 21.7191 39.8213 22.3947L39.3653 44.84C39.3653 45.3467 39.1795 45.7858 38.8079 46.1573ZM35.9199 51.4267C36.359 50.9876 36.8826 50.768 37.4906 50.768C38.0986 50.768 38.6053 50.9876 39.0106 51.4267C39.4497 51.832 39.6693 52.3387 39.6693 52.9467V54.8213C39.6693 55.4293 39.4497 55.9529 39.0106 56.392C38.6053 56.7973 38.0986 57 37.4906 57C36.8826 57 36.359 56.7973 35.9199 56.392C35.5146 55.9529 35.3119 55.4293 35.3119 54.8213V52.9467C35.3119 52.3387 35.5146 51.832 35.9199 51.4267Z",
    fill: "#6B35B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.a7def18149f3c457f2bca499d939a5b2.svg";
export { ForwardRef as ReactComponent };